import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { i18n, t } from './i18n';
import './styles.css';
import './theme.css';
import './lib/theme';
const app=createApp(App);
app.use(createPinia()).use(i18n).use(router);
void router.isReady().then(()=>app.mount('#app')).catch(()=>{
  const message=document.querySelector('#app .boot-message');
  if(message)message.textContent=t('common.bootError');
  const retry=document.querySelector<HTMLButtonElement>('#app .boot-retry');
  if(retry){retry.hidden=false;retry.addEventListener('click',()=>window.location.reload());}
});
